module.exports = __webpack_public_path__ + "static/media/fiberpay-white.39b7e4e0.svg";